
/**
 * Cell contains the data used to display a td 
 * CellContent contains the content of the td cell 
 * 
 * TODO: merge, compare, log 
 * TODO: in the constructor only keep data accessors 
 */



export class CellContent{
    constructor(){
        var _content = [];

        Object.defineProperty(this,'content',{
            get : function(){ return _content }
        })

    }
    // ==========
    // private
    // ----------

    getContent(){ return this.content }

    getContentAsHtml(){
        var content = this.getContent();
        var html = '';
        content.forEach(entry =>{
            var { string, className } = entry;
                html += `<span`;
                if (className) html += ` class="${className}"`;
                html += `>${string}</span> `
        });
        return html;
    }

    // ==========
    // public
    // ----------
    add(string,className){
        this.getContent().push({ string, className })
    }

    log(){
        return this.getContentAsHtml();
    }

}


export class Cell{
    constructor(cellOption){  
        var _cellContent = new CellContent(),
            _classSet = new Set(),
            _style = {},
            _merge = false,
            _span = 1
        ;

        Object.defineProperty(this,'cellContent',{
            get : ()=>_cellContent,
            enumerable : false 
        });


        Object.defineProperty(this,'classSet',{
            get : ()=>_classSet,
            enumerable : false 
        });

        Object.defineProperty(this,'style',{
            get : ()=>_style,
            enumerable : false 
        });

        Object.defineProperty(this,'span',{
            set : (n) =>{ _span = n },
            get : ()=>_span,
            enumerable : false 
        });

        Object.defineProperty(this,'merge',{  // merge === mergeWithPrevious
            set : (m)=>{ _merge = m },
            get : ()=>_merge,
            enumerable : false 
        });



        this.initCell(cellOption);

    }
    // ==========
    // private
    // ----------
    getCellContent(){ return this.cellContent; }

    getClassSet(){ return this.classSet }

    getStyle(){ return this.style }



    initCell(cellOption){
        if (cellOption){
            if (cellOption.classes) cellOption.classes.forEach(klass => this.addClass(klass));
            if (cellOption.style) Object.entries(cellOption.style).forEach(([prop,value])=>{ this.addStyle(prop,value) });
            if (cellOption.merge ) this.setMerge(cellOption.merge);
            if (cellOption.content){
                if (cellOption.content instanceof Array){  // TODO use utils
                    cellOption.content.forEach(entry =>{
                        if (entry.string) this.addContent(entry.string, entry.className);
                        if (typeof entry === 'string') this.addContent(entry)                   
                    })
                } 
                if (typeof cellOption.content === 'string' ){  // TODO use utils 
                      this.addContent(cellOption.content)  
                }
            }
        }
    }

    // ==========
    // public 
    // ----------
    addContent(string, className){ this.getCellContent().add(string, className);  }

    getContentAsHtml(){ return this.getCellContent().getContentAsHtml() }

    addClass(c){ 
        if (typeof c === 'string'){
            this.getClassSet().add(c);
        }
    }

    hasClasses(){ return this.getClasses().size }

    getClasses(){  return [...this.getClassSet().values()].join(',')  };


    addStyle(prop, value){
        var style = this.getStyle();
        var s = {};
        s[prop] = value; 
        Object.assign(style,s); 
    };

    getStyle(){ return this.style }

    setMerge(b){ 
        this.merge = b; 
    }
    
    getMerge(){ return this.merge }

    setSpan(n){ this.span = n }

    getSpan(){ return this.span }

    log(){
        return this.getCellContent().log()
    }


    // ==========
    // static 
    // ----------


}

/**
 * CellOption interface
 * classes : array of strings 
 * style : object literal key : value (ex: 'border' : '1px solid red' )
 * merge : boolean 
 * content : array of {string, className} || array of strings || string
 */
class CellOption{}